const PINNED_BAR_CLASS = "is-pinned-to-page-bottom";
const FOOTER_SELECTOR = "[data-footer-section]";
const SECTION_SELECTOR = ".shopify-section";
const PIN_DISTANCE_INTO_VIEWPORT = 4;
const BAR_BOTTOM_TOLERANCE = 4;

window._sections = window._sections || {};

const isFooterInView = (footer, distanceIntoViewport) =>
  footer.getBoundingClientRect().top < window.innerHeight - distanceIntoViewport;

const isBarAtViewportBottom = (section) =>
  section.getBoundingClientRect().bottom >= window.innerHeight - BAR_BOTTOM_TOLERANCE;

const pinAddToCartBarToPageBottom = (barElement) => {
  const section = barElement.closest(SECTION_SELECTOR);
  const footer = document.querySelector(FOOTER_SELECTOR);
  if (!section || !footer) return;

  const updateBarPosition = () => {
    if (!section.isConnected) {
      window.removeEventListener("scroll", updateBarPosition);
      window.removeEventListener("resize", updateBarPosition);
      return;
    }
    const isPinned = section.classList.contains(PINNED_BAR_CLASS);
    if (isPinned) {
      if (!isFooterInView(footer, 0)) section.classList.remove(PINNED_BAR_CLASS);
      return;
    }
    if (isFooterInView(footer, PIN_DISTANCE_INTO_VIEWPORT) && isBarAtViewportBottom(section)) {
      section.classList.add(PINNED_BAR_CLASS);
    }
  };

  window.addEventListener("scroll", updateBarPosition, { passive: true });
  window.addEventListener("resize", updateBarPosition, { passive: true });
  updateBarPosition();
};

window._sections["pinAddToCartBarToPageBottom"] = pinAddToCartBarToPageBottom;
